module.exports = __webpack_public_path__ + "img/cnbv.6f0036c7.png";